import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="booking-location"
export default class extends Controller {
  static values = {
    settings: Object,
  };
  connect() {
    console.log(this.settingsValue);
  }

  change(event) {
    console.log(event.target.value, event.params);
  }
}
